import { toast } from "react-toastify";
import screenType from "../models/guest";
import { ISpeaker } from "../models/podium";
import { ITenant } from "../models/tenant";

import { history } from "../..";
export type QRDataType = "guestUrl" | "screenUrl" | "allowChoice";



const baseURL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_DOMAIN + process.env.REACT_APP_API_URL
  : "/api";

export const codeQuerystringParameter = "code";;
export const screenQuerystringParameter = "screen";
export const fingerPrintstringParameter="fingerprint"

export const getScreenAppUrl = () => {
  const envValue = process.env.REACT_APP_SCREENAPP_URL;
  const isNativeApp = process.env.REACT_APP_IS_NATIVE_APP === "true";
  let path = "/screen";
  if (isNativeApp) return `${process.env.REACT_APP_DOMAIN}${path}`;
  if (envValue) {
    if (envValue.startsWith("http")) return envValue;
    else path = envValue;
  }
  return `${window.location.protocol}//${window.location.host}${path}`;
};

export const getTenantQrStyleUrl = (tenant: ITenant) => {
  const path = tenant.path.startsWith("/") ? tenant.path : "/" + tenant.path;
  return `${process.env.REACT_APP_LOGO_PATH}json/tenants${path}/qrstyle.json`;
};

export const getSpeakerIconUrl = (speaker: ISpeaker) => {
  const ts = new Date().getMilliseconds();
  // const url = `${baseURL}/podium/speakers/${speaker.id}/icon?ts=${ts}`;
  const url = `${baseURL}/public/podium/speakers/${speaker.id}/icon`;
  return url
}

export const getPodiumBackgroundImageUrl = (meetingId: string) => {
  const ts = new Date().getMilliseconds();
  const url = `${baseURL}/public/podium/meetings/${meetingId}/backgrounds/background?ts=${ts}`;
  return url
}
export const getQRDataUrl = (
  type: string,
  screen: string,
  code: string,
  screenTypeId: number,
  fingerPrint: string
) => {
  switch (type) {
    case "guestUrl":
      return getGuestUrl(code);
    case "screenUrl":
      return getConnectScreenUrl(screen, code,screenTypeId,fingerPrint);
    case "allowChoice":
    default:
      return getQrRedirectUrl(screen, code,screenTypeId,fingerPrint);
  }
};

export const getGuestUrl = (code: string) => {
  //const playerUrl = getPlayerUrl();
  // return `${playerUrl}/guest?${codeQuerystringParameter}=${code}`;
  return `/guest/guest?${codeQuerystringParameter}=${code}`;
};

export const getConnectScreenUrl = (screen: string, code: string, screentypeId: number, fingerPrint: string) => {
  const screenUrl = getScreenAppUrl();
  switch (screentypeId)
  {
      case screenType.Single:
        return `${screenUrl}/${screen}?${codeQuerystringParameter}=${code}`;
      case screenType.Template:
        return `${screenUrl}/${screen}/${fingerPrint}`;
      default:
         return "";
  }
};


export const getQrRedirectUrl = (screen: string, code: string, screentypeId: number, fingerPrint : string) => {
  const screenUrl = getScreenAppUrl();
  switch (screentypeId)
  {
      case screenType.Single:
        return `${screenUrl}/redirect?${codeQuerystringParameter}=${code}&${screenQuerystringParameter}=${screen}`;
      case screenType.Template:
        return `${screenUrl}/redirect?${codeQuerystringParameter}=${code}&${screenQuerystringParameter}=${screen}&${fingerPrintstringParameter}=${fingerPrint}`;
      default:
         return "";
  }
  
};
export const RemovelauncherGuestScreenLocalSession = () => {
  localStorage.removeItem('launcherGuestScreen');  
};

export const RedirectGuestScreen = (additionalUrl? : string) => {
  console.log("RedirectGuestScreen");
  var launcherGuestScreen= localStorage.getItem('launcherGuestScreen');
  if(launcherGuestScreen){
    window.location.href = `/guest/guestscreen`
  }else{
    if(additionalUrl)
      window.location.href = `/guest${additionalUrl}`
      else
      // *Aggiunto questo per sforzare il redirect alla pagina guest per far apparire in caso la scrollbar facendo ricaricare di nuovo tutta la pagina
      // A volte la scrollbar non appare dopo che si è fatto esci 
    window.location.href = `/guest`
  }
};



export const safeEncodeURIComponent = (value: any) => {
  if (typeof value === 'string') {
    value = value.replace(/%/g, '%25');
  }
  return encodeURIComponent(value);
};

export const safeDecodeURIComponent = (param : any) => {
  try {
    return decodeURIComponent(param);
    // if (typeof result === 'string') {
    //   result = result.replace("&@1245&@", '%');
    // }
  } catch (e) {
    console.error(`Error decoding parameter ${param}:`, e);
    return param;
  }
};